module.exports = __webpack_public_path__ + "static/media/miniWaitStateReactLogo.5d5d9eef.svg";